export default __webpack_public_path__ + "static/media/prev_icon.00979e99.svg";